import { requestUser } from "../../apis";

export const apiRequestSignIn = (params: any): any =>
  requestUser("post", `/api/login`, params, false);

export const apiForgotPasswordMailSend = (params: any): any =>
  requestUser("post", `/api/mail/forget/send`, params, false);

export const apiForgotPassword = (params: any): any =>
  requestUser("put", `/api/forget/password`, params, true);
